/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { skillsControllerCreate } from "./skillsControllerCreate";
import { skillsControllerFindAll } from "./skillsControllerFindAll";
import { skillsControllerFindOne } from "./skillsControllerFindOne";
import { skillsControllerRemove } from "./skillsControllerRemove";
import { skillsControllerUpdate } from "./skillsControllerUpdate";

export function skillsService() {
  return { skillsControllerCreate, skillsControllerFindAll, skillsControllerRemove, skillsControllerUpdate, skillsControllerFindOne }
}